import {
  BookOpen,
  Castle,
  Compass,
  Flame,
  HeartPulse,
  Map,
  Shield,
  Sprout,
  UsersRound
} from "lucide-react";
import { TranslationKey } from "@/i18n/translations";

export const release = {
  targetDateIso: null as string | null,
  estimatedWindowKey: "buy.release.window" as TranslationKey
};

export const studioEmailKey = "contact.email" as TranslationKey;

export const navItems = [
  { href: "/", labelKey: "nav.home" },
  { href: "/about", labelKey: "nav.about" },
  { href: "/world", labelKey: "nav.world" },
  { href: "/media", labelKey: "nav.media" },
  { href: "/buy", labelKey: "nav.buy" },
  { href: "/contact", labelKey: "nav.contact" }
] as const;

export const featureCards = [
  {
    icon: UsersRound,
    titleKey: "home.pillar.colony.title",
    bodyKey: "home.pillar.colony.body"
  },
  {
    icon: Shield,
    titleKey: "home.pillar.leader.title",
    bodyKey: "home.pillar.leader.body"
  },
  {
    icon: Sprout,
    titleKey: "home.pillar.verdancia.title",
    bodyKey: "home.pillar.verdancia.body"
  },
  {
    icon: Map,
    titleKey: "home.pillar.world.title",
    bodyKey: "home.pillar.world.body"
  }
] satisfies Array<{
  icon: typeof UsersRound;
  titleKey: TranslationKey;
  bodyKey: TranslationKey;
}>;

export const developmentPoints: TranslationKey[] = [
  "home.development.point1",
  "home.development.point2",
  "home.development.point3",
  "home.development.point4"
];

export const conceptGallery = [
  {
    id: "key-art",
    image: "/concepts/verdantfall-hero.png",
    titleKey: "media.heroConcept.title",
    bodyKey: "media.heroConcept.body",
    aspect: "wide"
  },
  {
    id: "aurel-colony",
    image: "/concepts/aurel-colony-concept.png",
    titleKey: "media.colony.title",
    bodyKey: "media.colony.body",
    aspect: "standard"
  },
  {
    id: "verdancia",
    image: "/concepts/verdancia-bloom-concept.png",
    titleKey: "media.verdancia.title",
    bodyKey: "media.verdancia.body",
    aspect: "square"
  },
  {
    id: "world-map",
    image: "/concepts/aurel-world-map-concept.png",
    titleKey: "media.map.title",
    bodyKey: "media.map.body",
    aspect: "wide"
  }
] satisfies Array<{
  id: string;
  image: string;
  titleKey: TranslationKey;
  bodyKey: TranslationKey;
  aspect: "wide" | "standard" | "square";
}>;

export const aboutCards = [
  {
    icon: Compass,
    titleKey: "about.card1.title",
    bodyKey: "about.card1.body"
  },
  {
    icon: HeartPulse,
    titleKey: "about.card2.title",
    bodyKey: "about.card2.body"
  },
  {
    icon: Castle,
    titleKey: "about.card3.title",
    bodyKey: "about.card3.body"
  }
] satisfies Array<{
  icon: typeof BookOpen;
  titleKey: TranslationKey;
  bodyKey: TranslationKey;
}>;

export const worldSystems = [
  { icon: Castle, key: "world.system.colony" },
  { icon: UsersRound, key: "world.system.people" },
  { icon: Compass, key: "world.system.region" },
  { icon: Flame, key: "world.system.combat" }
] satisfies Array<{ icon: typeof BookOpen; key: TranslationKey }>;

export const progressionSteps: TranslationKey[] = [
  "world.progression.one",
  "world.progression.two",
  "world.progression.three"
];
